import React, { useState, useEffect } from 'react';
import { Swipeable } from 'react-swipeable';
import { onSwipeLeft, onSwipeRight, applyTransition, } from '@nykaa/deals-utils/slider';
import ProgressiveDots from './ProgressiveDots';
import Dots from './dots';
import { CarouselWrapper, SlideSanptogridWrapper, SlidesContainer, SlideWrapper, SnaptogridContainer, DescriptionSlide, IndicatorPosition, SliderTitleWrapper, SliderTitleWrapperCommon, LeftArrow, RightArrow, CarouselDesktopbgWrapper, } from './css';
import constants from './constants';
const CarouselV2 = (widgetData) => {
    const { params, children, id, cssStyle, isDesktop, } = widgetData;
    const { delayTimer, carouselType, title, autoScroll, description, bkgColor, positionIndicatorFlag, } = params;
    let delayAutoTimer = 0;
    if (autoScroll && autoScroll === 'True') {
        delayAutoTimer = delayTimer === 0 ? 8000 : delayTimer;
    }
    else {
        delayAutoTimer = 0;
    }
    const isShowingIndicator = (positionIndicatorFlag && positionIndicatorFlag === 'on');
    const { titleStyle, spacingStyle, positionindicatorStyle } = cssStyle;
    const [activeSlide, changeSlide] = useState(0);
    const [intervalState, setIntervalState] = useState(null);
    const slides = children;
    const slidesLength = slides.length;
    const swipeRightHandler = () => {
        changeSlide(onSwipeRight(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const swipeLeftHandler = () => {
        changeSlide(onSwipeLeft(activeSlide, slidesLength));
        setIntervalState(clearInterval(intervalState));
    };
    const rightClickHandler = () => {
        const newSlide = activeSlide + 1;
        if (newSlide < slidesLength) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(0);
        }
    };
    const leftClickHandler = () => {
        const newSlide = activeSlide - 1;
        if (newSlide >= 0) {
            changeSlide(newSlide);
        }
        else {
            changeSlide(slidesLength - 1);
        }
    };
    const clearAutoplay = () => {
        if (!delayAutoTimer) {
            return;
        }
        setIntervalState(clearInterval(intervalState));
    };
    const setAutoplay = () => {
        if (!delayAutoTimer) {
            return;
        }
        const interval = setInterval(() => {
            swipeLeftHandler();
        }, delayAutoTimer);
        setIntervalState(interval);
    };
    /**
     * @description this check added if widgetdata changes in post calls
     * previously without checkout childrens length is not updating into the
     * rerenders.
     */
    useEffect(() => {
        if (slides && slidesLength > 0) {
            clearAutoplay();
            applyTransition(activeSlide, id, cssStyle.spacingStyle.interItem, carouselType);
            setAutoplay();
        }
    }, [activeSlide, slides, slidesLength]);
    const { edgeToEdgeIndicator, snapToGridIndicator, indicator } = positionindicatorStyle;
    const isNewTemplate = !!(edgeToEdgeIndicator || snapToGridIndicator);
    const indicatorType = (templateType, type) => ((templateType === null || templateType === void 0 ? void 0 : templateType.type) === type);
    const edgeToEdgeType = (templateType) => (indicatorType(templateType, constants.PROGRESSIVE)
        || indicatorType(templateType, constants.BAR));
    const isEdgeToEdgeType = (isNewTemplate
        ? edgeToEdgeType(edgeToEdgeIndicator)
        : edgeToEdgeType(indicator));
    const isProgrssiveIndicator = (isNewTemplate
        ? indicatorType(edgeToEdgeIndicator, constants.PROGRESSIVE)
        : indicatorType(indicator, constants.BAR));
    return (React.createElement(CarouselDesktopbgWrapper, { bkgColor: bkgColor, isDesktop: isDesktop },
        React.createElement(CarouselWrapper, { wrapperSpacing: spacingStyle, bkgColor: bkgColor, isDesktop: isDesktop, id: id },
            carouselType === 'edgetoedge' && (React.createElement("div", { className: "swtitleWrapper" },
                React.createElement(SliderTitleWrapperCommon, { titleCss: titleStyle },
                    React.createElement("span", { className: "carouseltitle" },
                        ' ',
                        title),
                    description && (React.createElement("div", null,
                        React.createElement(DescriptionSlide, { titleCss: cssStyle.descriptionStyle }, description)))))),
            carouselType === 'snaptogrid' ? (React.createElement("div", { className: carouselType },
                React.createElement("div", { className: "swtitleWrapper" },
                    React.createElement(SliderTitleWrapper, { titleCss: titleStyle },
                        React.createElement("span", { className: "carouseltitle" },
                            ' ',
                            title),
                        description && (React.createElement("div", null,
                            React.createElement(DescriptionSlide, { titleCss: cssStyle.descriptionStyle }, description)))),
                    (isShowingIndicator)
                        && (slidesLength > 1 && (React.createElement(IndicatorPosition, { titleCss: cssStyle.descriptionStyle, positionIndicator: positionindicatorStyle, className: "carouselindicator", isNewTemplate: isNewTemplate },
                            ' ',
                            activeSlide + 1,
                            ' ',
                            "of",
                            ' ',
                            slidesLength)))),
                React.createElement(Swipeable, { onSwipedRight: () => swipeRightHandler(), onSwipedLeft: () => swipeLeftHandler(), delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: true, trackMouse: true, rotationAngle: 0, style: { height: '90%', width: '100%' } },
                    React.createElement(SnaptogridContainer, { className: "sliderbannerWrapper", swPadding: cssStyle.spacingStyle.padding },
                        (isDesktop && slidesLength > 1)
                            && React.createElement(LeftArrow, { onClick: leftClickHandler }),
                        (isDesktop && slidesLength > 1)
                            && React.createElement(RightArrow, { onClick: rightClickHandler }),
                        slides.map((slide) => (React.createElement(SlideSanptogridWrapper, { isDesktop: isDesktop, key: id, interItem: cssStyle.spacingStyle.interItem, className: id }, slide)))))))
                : (React.createElement("div", { className: carouselType },
                    React.createElement(Swipeable, { onSwipedRight: () => swipeRightHandler(), onSwipedLeft: () => swipeLeftHandler(), delta: 10, preventDefaultTouchmoveEvent: false, trackTouch: true, trackMouse: true, rotationAngle: 0, style: { height: '90%', width: '100%' } },
                        React.createElement(SlidesContainer, { swPadding: cssStyle.spacingStyle.padding },
                            (isDesktop && slidesLength > 1)
                                && React.createElement(LeftArrow, { onClick: leftClickHandler }),
                            (isDesktop && slidesLength > 1)
                                && React.createElement(RightArrow, { onClick: rightClickHandler }),
                            slides.map((slide) => (React.createElement(SlideWrapper, { className: id }, slide))))),
                    isShowingIndicator && (isEdgeToEdgeType
                        ? (React.createElement(ProgressiveDots, { length: slidesLength, active: activeSlide, isNewTemplate: isNewTemplate, timer: isProgrssiveIndicator ? delayAutoTimer : 0, onClickHandler: (clickedIndex) => changeSlide(clickedIndex), positionindicatorCss: positionindicatorStyle }))
                        : (React.createElement(Dots, { length: slidesLength, active: activeSlide, onClickHandler: (clickedIndex) => changeSlide(clickedIndex), positionindicatorCss: positionindicatorStyle, isNewTemplate: isNewTemplate }))))))));
};
export default CarouselV2;
